import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoIosArrowForward } from "react-icons/io";
import { FiTrash2 } from "react-icons/fi";

import {
  get_card_products,
  delete_card_product,
  messageClear,
  quantity_inc,
  quantity_dec,
  apply_coupon,
  clearCoupon
} from '../store/reducers/cardReducer';

import toast from 'react-hot-toast';

import {
  FaTrash,
  FaTag,
  FaCheckCircle,
  FaTimesCircle,
  FaTicketAlt,
} from 'react-icons/fa';
import { FiLoader } from 'react-icons/fi';

import { useCurrency } from '../context/CurrencyContext';

const Card = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { userInfo } = useSelector(state => state.auth);

  const {
    card_products,
    successMessage,
    errorMessage,
    price,
    buy_product_item,
    shipping_fee,
    outofstock_products,
    coupon,
    couponDiscount,
    discountedPrice,
    couponLoading
  } = useSelector(state => state.card);

  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (card_products.length > 0) {
        const allIds = [];

        card_products.forEach(shop => {
            shop.products.forEach(item => {
            allIds.push(item._id);
          });
        });

        setSelectedItems(allIds);
      }
    }, [card_products]);

  const { formatBase } = useCurrency();

  const [couponCode, setCouponCode] = useState(location.state?.prefillCoupon || '');

  useEffect(() => {
    dispatch(get_card_products(userInfo.id));
  }, [dispatch, userInfo.id]);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      if (successMessage !== 'Coupon applied') {
        dispatch(get_card_products(userInfo.id));
      }
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [errorMessage]);

  const redirect = () => {
    const selectedCardProducts = card_products
      .map(shop => ({
        ...shop,
        products: shop.products.filter(p => selectedItems.includes(p._id))
      }))
      .filter(shop => shop.products.length > 0);

    const originalPrice = selectedTotal;
    const adjustedDiscount = coupon ? Math.min(couponDiscount, selectedTotal) : 0;
    const productTotal = Math.max(originalPrice - adjustedDiscount, 0);
    const selectedCoupon = coupon ? { ...coupon, discount: adjustedDiscount } : null;

    navigate('/shipping', {
      state: {
        products: selectedCardProducts,
        price: productTotal,
        originalPrice,
        shipping_fee,
        items: selectedCount,
        coupon: selectedCoupon
      }
    });
  };

  const applyCoupon = () => {
    if (!couponCode.trim()) {
      return toast.error('Enter coupon code');
    }

    dispatch(apply_coupon({
      code: couponCode,
      cartTotal: price,
      products: card_products,
      userId: userInfo.id
    }));
  };

  const removeCoupon = () => {
    setCouponCode('');
    dispatch(clearCoupon());
  };

  const inc = (quantity, stock, card_id) => {
    if (quantity + 1 <= stock) {
      dispatch(quantity_inc(card_id));
    }
  };

  const dec = (quantity, card_id) => {
    if (quantity - 1 !== 0) {
      dispatch(quantity_dec(card_id));
    }
  };

  const allProductIds = [];

card_products.forEach(shop => {
  shop.products.forEach(item => {
    allProductIds.push(item._id);
  });
});

const handleSelectItem = (id) => {
  setSelectedItems(prev => {
    if (prev.includes(id)) {
      return prev.filter(itemId => itemId !== id);
    } else {
      return [...prev, id];
    }
  });
};

const handleSelectAll = () => {
  if (selectedItems.length === allProductIds.length) {
    setSelectedItems([]);
  } else {
    setSelectedItems(allProductIds);
  }
};

// SELECTED PRODUCTS
const selectedProducts = [];

card_products.forEach(shop => {
  shop.products.forEach(item => {
    if (selectedItems.includes(item._id)) {
      selectedProducts.push(item);
    }
  });
});

// SELECTED ITEM COUNT
const selectedCount = selectedProducts.reduce(
  (total, item) => total + item.quantity,
  0
);

// SELECTED TOTAL PRICE
const selectedTotal = selectedProducts.reduce((total, item) => {

  const finalPrice =
    item.productInfo.price -
    Math.floor(
      (item.productInfo.price * item.productInfo.discount) / 100
    );

  return total + (finalPrice * item.quantity);

}, 0);

  return (
  <div className="bg-white min-h-screen">
    <Header />

    <div className="w-[92%] lg:w-[92%] mx-auto py-6">

      {/* BREADCRUMB */}
      <div className="text-sm text-gray-500 mb-5 flex items-center gap-2">
        <Link to="/">Home</Link>
        <IoIosArrowForward className="text-xs" />
        <span className="text-black">Cart</span>
      </div>

      {
        card_products.length > 0 ? (

          <div className="grid grid-cols-[1fr_420px] gap-12 lg:grid-cols-1">

            {/* LEFT SIDE */}
            <div className="bg-white p-0">
                
                {/* FREE SHIPPING BAR */}
                <div className="bg-[#edf7ea] rounded-[6px] p-2 flex items-center justify-between mb-5">
                    <div className="flex items-center gap-3">
                        <div className="w-6 h-6 rounded-full bg-green-600 text-white flex items-center justify-center font-bold">
                            ✓
                        </div>

                        <span className="font-semibold text-[16px]">
                            Free shipping special for you
                        </span>
                    </div>

                    <span className="text-sm text-gray-600">
                        Limited-time offer
                    </span>
                </div>

              {/* SELECT HEADER */}
              <div className="flex items-center justify-between border-b pb-4 mb-6 flex-wrap gap-4">

                <div className="flex items-center gap-3">

                    {/* SELECT ALL BUTTON */}
                    <button
                        onClick={handleSelectAll}
                        className={`w-5 h-5 rounded-full flex items-center justify-center text-sm font-bold transition
                        ${
                            selectedItems.length === allProductIds.length
                            ? "bg-black text-white"
                            : "border border-gray-400 text-transparent"
                        }`}
                    >
                        ✓
                    </button>

                    <h2 className="text-[16px] font-semibold">
                        Select all ({allProductIds.length})
                    </h2>

                </div>

                <div className="flex items-center gap-3">

                    <button className="border rounded-full px-6 py-1 text-[16px] bg-white text-black">
                        All ({allProductIds.length})
                    </button>

                    <button className="border rounded-full px-6 py-1 text-[16px]">
                        Selected ({selectedItems.length})
                    </button>

                </div>

              </div>

              {/* PRODUCTS */}
              <div className="flex flex-col">

                {
                  card_products.map((shop, i) => (

                    <div key={i}>

                      {
                        shop.products.map((pt, index) => {

                          const finalPrice =
                            pt.productInfo.price -
                            Math.floor(
                              (pt.productInfo.price * pt.productInfo.discount) / 100
                            );

                          return (

                            <div
                              key={index}
                              className="flex gap-5 border-b py-6 lg:flex-col"
                            >

                              {/* CHECKBOX */}
                              <div className="pt-10">
                                <button
                                    onClick={() => handleSelectItem(pt._id)}
                                    className={`w-5 h-5 rounded-full flex items-center justify-center text-sm font-bold transition
                                    ${
                                        selectedItems.includes(pt._id)
                                        ? "bg-black text-white"
                                        : "border border-gray-400 text-transparent"
                                    }`}
                                >
                                    ✓
                                </button>
                              </div>

                              {/* IMAGE */}
                              <div className="w-[128px] h-[128px] bg-[#f8f8f8] rounded-[6px] overflow-hidden flex-shrink-0">

                                <img
                                  src={pt.productInfo.images[0]}
                                  alt=""
                                  className="w-full h-full object-cover"
                                />

                              </div>

                              {/* CONTENT */}
                              <div className="flex-1 flex flex-col justify-between">

                                <div>

                                  {/* TITLE */}
                                  <h2 className="text-[16px] leading-[32px] text-gray-700 line-clamp-2">
                                    {pt.productInfo.name}
                                  </h2>

                                  {/* <p className="text-gray-500 mt-0">
                                    {pt.productInfo.brand}
                                  </p> */}

                                  {/* BIG SALE */}
                                  <div className="mt-4 flex items-center gap-3">

                                    <span className="text-orange-500 font-bold text-[14px]">
                                      Big sale
                                    </span>

                                    <div className="h-[6px] w-[120px] bg-orange-200 rounded-full overflow-hidden">

                                      <div className="h-full w-[70%] bg-orange-500 rounded-full"></div>

                                    </div>

                                    <span className="text-orange-500 font-semibold text-[14px]">
                                      Limited time
                                    </span>

                                  </div>

                                  {/* OLD PRICE */}
                                  <div className="mt-0">

                                    <span
                                      className="text-[18px] text-black/60 font-medium relative inline-block"
                                      style={{
                                        textDecoration: "line-through",
                                        textDecorationThickness: "3px",
                                        textDecorationColor: "rgba(0,0,0,0.45)"
                                      }}
                                    >
                                      {formatBase(pt.productInfo.price)}
                                    </span>

                                  </div>

                                  {/* NEW PRICE */}
                                  <div className="flex items-center gap-3 mt-0 flex-wrap">

                                    <h2 className="text-[18px] font-bold text-orange-500 leading-none">
                                      {formatBase(finalPrice)}
                                    </h2>

                                    <span className="text-[16px] text-gray-700">
                                      after promos
                                    </span>

                                    <div className="border border-orange-500 text-orange-500 px-[6px] py-[1px] rounded text-[13px] font-semibold">
                                      -{pt.productInfo.discount}%
                                    </div>

                                  </div>

                                  {/* DELIVERY */}
                                  <p className="mt-0 text-[13x] text-gray-500">
                                    Delivery: 4-9 business days
                                  </p>

                                </div>

                              </div>

                              {/* RIGHT SIDE */}
                              <div className="flex flex-col justify-between items-end">

                                {/* DELETE */}
                                <button
                                    onClick={() => dispatch(delete_card_product(pt._id))}
                                    className="group w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 hover:border-red-200 hover:bg-red-50 transition-all duration-200"
                                >
                                    <FiTrash2 className="text-[18px] text-gray-400 group-hover:text-red-500 transition-colors duration-200" />
                                </button>

                                {/* QTY */}
                                <div className="border border-gray-600 rounded-lg overflow-hidden">

                                  <select
                                    value={pt.quantity}
                                    onChange={(e) => {
                                      const value = Number(e.target.value);

                                      if (value > pt.quantity) {
                                        dispatch(quantity_inc(pt._id));
                                      } else if (value < pt.quantity) {
                                        dispatch(quantity_dec(pt._id));
                                      }
                                    }}
                                    className="px-4 py-1 outline-none bg-white text-[14px]"
                                  >

                                    {
                                      [...Array(50).keys()].map(n => (
                                        <option key={n + 1} value={n + 1}>
                                          Qty {n + 1}
                                        </option>
                                      ))
                                    }

                                  </select>

                                </div>

                              </div>

                            </div>

                          );
                        })
                      }

                    </div>

                  ))
                }

              </div>

            </div>

            {/* RIGHT SUMMARY */}
            <div>
              <div className="bg-white sticky top-24 rounded-2xl border border-gray-100 shadow-sm overflow-hidden">

                {/* Header */}
                <div className="px-5 py-4 border-b border-gray-100">
                  <h2 className="text-[16px] font-bold">Order Summary</h2>
                </div>

                <div className="px-5 py-4 space-y-3">

                  {/* Subtotal row */}
                  <div className="flex justify-between text-[14px]">
                    <span className="text-gray-500">Subtotal ({selectedCount} items)</span>
                    <span className="font-semibold text-gray-800">{formatBase(selectedTotal)}</span>
                  </div>

                  {/* Coupon discount row — only when applied */}
                  {coupon && couponDiscount > 0 && (
                    <div className="flex justify-between text-[14px]">
                      <span className="text-green-600 font-medium flex items-center gap-1">
                        <FaTag size={11} /> Coupon ({coupon.code})
                      </span>
                      <span className="text-green-600 font-bold">-{formatBase(couponDiscount)}</span>
                    </div>
                  )}

                  {/* Shipping */}
                  <div className="flex justify-between text-[14px]">
                    <span className="text-gray-500">Shipping</span>
                    <span className="text-green-600 font-bold">FREE</span>
                  </div>

                  <div className="border-t border-dashed border-gray-200 pt-3">
                    <div className="flex justify-between items-center">
                      <span className="text-[16px] font-bold">Total</span>
                      <span className="text-[20px] font-bold text-[#ff7a00]">
                        {formatBase(coupon ? discountedPrice : selectedTotal)}
                      </span>
                    </div>
                    {coupon && couponDiscount > 0 && (
                      <div className="flex justify-end mt-1.5">
                        <span className="inline-flex items-center gap-1 bg-green-50 text-green-700 text-[12px] font-semibold px-3 py-1 rounded-full border border-green-100">
                          <FaCheckCircle size={10} /> You save {formatBase(couponDiscount)}
                        </span>
                      </div>
                    )}
                  </div>

                </div>

                {/* Coupon section */}
                <div className="px-5 pb-5">

                  {coupon ? (
                    /* Applied coupon banner */
                    <div className="mb-4 rounded-xl border border-green-200 bg-green-50 px-4 py-3">
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2 min-w-0">
                          <FaCheckCircle className="text-green-600 shrink-0" size={15} />
                          <div className="min-w-0">
                            <p className="text-[11px] text-green-600 font-semibold uppercase tracking-wide">Coupon applied</p>
                            <p className="font-bold text-gray-900 font-mono text-[15px] truncate">{coupon.code}</p>
                          </div>
                        </div>
                        <button
                          onClick={removeCoupon}
                          className="flex items-center gap-1 text-[12px] font-semibold text-red-400 hover:text-red-600 shrink-0 transition"
                          aria-label="Remove coupon"
                        >
                          <FaTimesCircle size={13} /> Remove
                        </button>
                      </div>
                    </div>
                  ) : (
                    /* Coupon input */
                    <div className="mb-4">
                      <div className="flex gap-2 mb-2">
                        <input
                          type="text"
                          placeholder="Enter coupon code"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                          onKeyDown={(e) => e.key === 'Enter' && applyCoupon()}
                          className="flex-1 border border-gray-200 rounded-full px-4 py-2.5 outline-none text-[14px] font-mono tracking-wider focus:border-orange-400 transition"
                        />
                        <button
                          onClick={applyCoupon}
                          disabled={couponLoading}
                          className="bg-black text-white px-5 rounded-full text-[13px] font-bold hover:bg-gray-800 disabled:opacity-60 transition flex items-center gap-1.5 shrink-0"
                        >
                          {couponLoading
                            ? <><FiLoader className="animate-spin" size={13} /> Applying...</>
                            : 'Apply'
                          }
                        </button>
                      </div>
                      <Link
                        to="/offers"
                        className="inline-flex items-center gap-1 text-[12px] text-orange-500 hover:text-orange-600 font-semibold transition"
                      >
                        <FaTicketAlt size={11} /> Browse available coupons
                      </Link>
                    </div>
                  )}

                  {/* Checkout button */}
                  <button
                    onClick={redirect}
                    disabled={selectedCount === 0}
                    className="w-full h-[50px] rounded-full bg-[#ff7a00] hover:bg-[#f06f00] disabled:opacity-50 text-white text-[16px] font-bold transition"
                  >
                    Checkout ({selectedCount})
                  </button>

                  <p className="text-center text-[11px] text-gray-400 mt-3">
                    Final amount confirmed at checkout.
                  </p>

                </div>

              </div>
            </div>

          </div>

        ) : (

          <div className="bg-white rounded-2xl p-20 md:p-8 md:text-center flex flex-col items-center justify-center">

            <h2 className="text-4xl md:text-2xl font-bold mb-4">
              Your cart is empty
            </h2>

            <p className="text-gray-500 mb-8">
              Looks like you haven’t added anything yet.
            </p>

            <Link
              to="/products"
              className="bg-[#ff7a00] hover:bg-[#f06f00] text-white px-10 py-4 rounded-full text-xl font-semibold"
            >
              Shop Now
            </Link>

          </div>

        )
      }

      {outofstock_products.length > 0 && (
        <div className="mt-6">
          <h3 className="text-[16px] font-semibold text-red-500 mb-3">Out of Stock Items</h3>
          <div className="flex flex-col gap-3">
            {outofstock_products.map((item, i) => (
              <div key={i} className="flex items-center justify-between border border-red-200 rounded-xl px-4 py-3 bg-red-50">
                <div className="flex items-center gap-3">
                  {item.products[0]?.images?.[0] && (
                    <img
                      src={item.products[0].images[0]}
                      alt={item.products[0].name}
                      className="w-14 h-14 object-cover rounded-lg"
                    />
                  )}
                  <div>
                    <p className="text-[14px] font-medium">{item.products[0]?.name}</p>
                    <p className="text-[12px] text-red-500">Out of stock</p>
                  </div>
                </div>
                <button
                  onClick={() => dispatch(delete_card_product(item._id))}
                  className="text-red-400 hover:text-red-600"
                >
                  <FaTrash />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>

    <Footer />
  </div>
);
};

export default Card;